export default "__VITE_ASSET__DXWk88l3__"